<script setup>
	import { ref, watch, inject } from 'vue'
	const $storeToasts = inject('$storeToasts')

	const toasts = ref([])
	const gotToasts = ref(false)

	watch(() => $storeToasts.toasts, ( newToasts ) => {
		toasts.value.push(newToasts)
		gotToasts.value = true
	})

</script>

<template>
	<div v-if="gotToasts" id="toasts-container">

		<template v-for="(toast, index) in toasts" :key="index">

			<div :class="`toast use-toast toast-${toast.style} show fade`" :style="`animation-delay: ${toast.delay ?? 3}s;`" data-bs-autohide="true">
				<div class="d-flex">
						<div class="toast-body">
							<div class="toast-icon">
								<FontAwesomeIcon v-if="toast.style == 'normal' || toast.style == 'success' || toast.style == 'delete'" icon="fas fa-check-circle" />
								<FontAwesomeIcon v-if="toast.style == 'warning'" icon="fas fa-exclamation-triangle" />
								<FontAwesomeIcon v-if="toast.style == 'danger'" icon="fas fa-times-circle" />
							</div>
							<div class="toast-content">
								{{ toast.content }}
							</div>
						</div>
				</div>
			</div>

		</template>
	</div>
</template>

<style lang="scss" scoped>
.bg-warning {
	color: #222 !important;
}

#toasts-container {
	z-index: 99991;

	.toast.show {
		opacity: 1;
		visibility: visible;
	}

	.toast[data-bs-autohide="true"] {
		animation: toggleToast 1s ease-in-out;
		animation-fill-mode: forwards;
	}
}

@keyframes toggleToast {
	0% {
		opacity: 1;
		visibility: visible;
		transform: scale(1) rotate(0);
	}
	20% {
		opacity: 1;
		visibility: visible;
		transform: scale(1.3) rotate(0);
	}
	35% {
		opacity: 0;
		visibility: hidden;
		transform: scale(0) rotate(-45deg) translateX(-50px);
	}
	100% {
		opacity: 0;
		visibility: hidden;
		position: absolute;
		top: -1000px;
		transform: scale(0) rotate(-45deg) translateX(-50px);
	}
}
</style>